<template>
  <s-modal
    v-model="showModalHandler"
    cancel-confirm-message-code="MC006"
    :title="$t('reports.save-template')"
    :ok-title="$t('general.save')"
    :ok-disabled="!nameHandler"
    :is-loading="isLoading"
    :confirm-type="confirmationTypes.YES_NO"
    @cancel="closeModal"
    @ok="saveTemplate"
  >
    <b-container fluid>
      <b-row>
        {{ $t('reports.oscillography.save-template-description') }}
      </b-row>
      <b-row class="mt-5">
        <b-col
          class="px-0"
          cols="12"
        >
          <b-form-group
            class="personal-data__form-field"
            label-for="name"
          >
            <label>
              {{ $t('fields.oscillography.template-name') }}
            </label>
            <b-form-input
              v-model="nameHandler"
              maxlength="80"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>
  </s-modal>
</template>

<script>
import confirmationTypes from '@/constants/confirmationTypes';

export default {
  name: 'SaveTemplateModal',
  props: {
    showModal: {
      type: Boolean,
    },
    value: {
      type: String,
    },
    isLoading: {
      type: Boolean,
    },
  },
  data: () => ({
    confirmationTypes,
  }),
  computed: {
    nameHandler: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    showModalHandler: {
      get() {
        return this.showModal;
      },
      set(val) {
        if (!val) {
          this.closeModal();
        }
      },
    },
  },
  methods: {
    closeModal() {
      this.$emit('close-modal');
    },
    saveTemplate() {
      this.$emit('save');
    },
  },
};
</script>
